<template>
    <div class="maintenance-tips-warp">
        <monitorTitle nub="6" text="维护提示" width="auto" />

        <div class="box">
            <div class="item" v-for="(i,k) in list" :key="k">
                <div class="value">{{i.value}}</div>
                <div class="label">{{i.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        data() {
            return {
                items: [],
                list: [{
                        name: '未处理保修工单',
                        value: 0,
                        key: 'num1'
                    },
                    {
                        name: '未处理换芯工单',
                        value: 0,
                        key: 'num2'
                    }
                ]
            }
        },
        watch: {
            Data(n) {
                this.getData()
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                let _data = {
                    num1: 0,
                    num2: 0
                }
                if (this.Data && this.Data.data6) {
                    _data = Object.assign(_data, this.Data.data6)
                }

                let list = this.list.map(i => {
                    let value = _data.hasOwnProperty(i.key) ? parseInt(_data[i.key]) : 0
                    return {
                        ...i,
                        value
                    }
                })

                this.list = list
            }
        }
    }
</script>

<style lang="less" scoped>
    .maintenance-tips-warp {
        width: 387px;

        .box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 45px;
            height: 238px;
            background-image: url("/static/images/home/chart-bg.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            .item {
                .value {
                    margin-bottom: 30px;
                    width: 120px;
                    height: 120px;
                    line-height: 120px;
                    font-family: WeChatNumber-151125;
                    font-size: 36px;
                    color: #0fc4ff;
                    text-align: center;
                    background-image: url("/static/images/home/maintenance-tips/bg.png");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                .label {
                    font-size: 16px;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
</style>
